<template>
  <div>
    <div class="content-video-section mt-4">
      <div class="row">
        <div
          class="col-12 col-sm-6"
          v-for="(data, index) in videos"
          :key="index"
        >
          <ContentVideoCard
            :id="data.id"
            :title="data.title"
            :extension="data.extension"
            :date="formatVideoDate(data.created_at)"
            :time="formatVideoTime(data.created_at)"
            :filename="data.filename"
            :thumbnail="data.thumbnail"
            :filetype="data.filetype"
            :tag="data.tag"
            :token="data.token"
            :user="data.user"
            :subscription_status="subscription_status"
          />
        </div>
      </div>
    </div>
  </div>
</template>
    
<script>
import { formatDate, formatTime } from "@/scripts/utilities";

export default {
  name: "ContentVideos",

  components: {
    ContentVideoCard: () =>
      import(
        /* webpackChunkName: "ContentVideoCard" */ "@/components/classComps/homework/ContentVideoCard"
      ),
  },
  props: {
    videos: Array,
    subscription_status: Boolean,
  },

  methods: {
    formatVideoDate(date) {
      let new_date = new Date(date.replace(/\s/, "T") + "Z");
      return formatDate(new_date);
    },

    formatVideoTime(date) {
      let new_date = new Date(date.replace(/\s/, "T") + "Z");
      return formatTime(new_date);
    },
  },
};
</script>

<style lang="scss">
</style>